import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";
import { IAssignee } from "../interface/IAssignee";
import IAssigneeResult from "../interface/trade/IAssigneeResult";
import IAssigneeSigner from "../interface/Assignee/IAssigneeSigner";
import ICessionarioJson from "../interface/Assignee/ICessionarioJson";
import IReplaceSignatoryRequest from "../interface/Assignee/IReplaceSignatoryRequest";
import { IAssigneeDocument } from "../interface/Assignee/IAssigneeDocument";
import { IAssigneeFile } from "../interface/Assignee/IAssigneeFile";

enum AssigneeServiceEnum {

  getSignersByAssigneeId = "/signers/by/assigneeId",
  save = "/add/signatory",
  getByContractTypeAndEmail = "/signers/by/contract/type/and/email/",
  replace = "/replace/signatory",
  searchSignatoryByEmail = "/signatory/by/email",

  getAll = "",
  getById = "",
  postAssign = "",
  putAssign = "",
  removeAssign = "",

  downloadAssignDocument = "/download",
  getAllAssignDocuments = "/files",
  uploadFile = "/upload",
  deleteFile = "/files"

}

export default class AssigneeService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/assignee");
  }

  public getAssignees = async (): Promise<IAssigneeResult> => await this.GET(AssigneeServiceEnum.getAll);
  public getSignersByAssigneeId = async (id, contractType): Promise<IAssigneeSigner> => await this.GET(AssigneeServiceEnum.getSignersByAssigneeId + `?id=${id}&contractType=${contractType}`);

  public searchSignatoryByEmail = async (email, signatoryType): Promise<ICessionarioJson> => await this.GET(AssigneeServiceEnum.searchSignatoryByEmail + `?email=${email}&signatoryType=${signatoryType}`);
  // public save = async data => await this.POST(AssigneeServiceEnum.save, data);

  public save = async (data: any): Promise<any[]> => await this.POST(AssigneeServiceEnum.save, data);

  // Manter Assygn-------
  public postAssign = async (data: IAssignee): Promise<IAssignee> => await this.POST(AssigneeServiceEnum.postAssign, data);
  public putAssign = async (Id: number, data: IAssignee): Promise<IAssignee> => await this.PUT(`${AssigneeServiceEnum.putAssign}/${Id}`, data);
  public removeAssign = async (Id: number): Promise<any> => await this.DELETE(`${AssigneeServiceEnum.removeAssign}/${Id}`);
  // IReplaceSignatoryRequest

  public replace = async (data: IReplaceSignatoryRequest): Promise<IReplaceSignatoryRequest> => await this.PUT(AssigneeServiceEnum.replace, data);

  public getByContractTypeAndEmail = async (id, contractType, email, signatoryType): Promise<ICessionarioJson> => await this.GET(AssigneeServiceEnum.getByContractTypeAndEmail + `?assigneeId=${id}&contractType=${contractType}&email=${email}&signatoryType=${signatoryType}`);

  public getAssigneeDetail = async (assigneeId: number): Promise<IAssignee> => await this.GET('/' + assigneeId);


  // ------------------------------------------------------------------Download de documentos--------------------------------------

  public updateFile = async (assigneeId: number, data: IAssigneeFile): Promise<any> => await this.PUT(`${AssigneeServiceEnum.uploadFile}/${assigneeId}`, data);

  public getAllDocument = async (assigneeId: number): Promise<IAssigneeDocument> => await this.GET(`${AssigneeServiceEnum.getAllAssignDocuments}/${assigneeId}`);

  public deleteFile = async (fileId: number): Promise<any> => await this.DELETE(`${AssigneeServiceEnum.deleteFile}/${fileId}`);

  public downloadDocument = async (file: IAssigneeDocument) => {
    const endpoint = `${AssigneeServiceEnum.downloadAssignDocument}/${file.documentId}`;
    const data = await this.GET(endpoint);
    this.downloadBase64File(data, 'application/octet-stream', file.fileName)
  };

  private downloadBase64File = (base64Data, contentType, fileName) => {
    const linkSource = `data:${contentType};base64,${base64Data}`;
    const downloadLink = document.createElement("a");
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }

}



// WEBPACK FOOTER //
// ./src/services/api/Assignee.service.ts